import React, { useState, useEffect } from "react";
// @mui material components
import Card from "@mui/material/Card";
import { CardHeader, Icon } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Switch from "@mui/material/Switch";
import MDInput from "components/MDInput";
import AccountingApi from "../../../../Classes/API/AccountingApi";
import CreateAccountingEntryReq from "../../../../Classes/Models/Requests/Accounting/CreateAccountingEntryReq";
import Swal from "sweetalert2";
import { useContext } from "react";
import { UserContext } from "App";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "App";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import RefundReq from "../../../../Classes/Models/Requests/Accounting/RefundReq";
import GenerateReceiptButton from "CinicComponents/GenerateReceiptButton";
import MDButton from "components/MDButton";
import "./pacakge.scss";
import PropTypes from "prop-types";
import PayFromBalanceReq from "Classes/Models/Requests/Accounting/PayFromBalanceReq";
import { PaidOutlined, PersonPinCircle, PersonPinCircleRounded } from "@mui/icons-material";
const PackageDetailsCard = ({
  Package,
  setShowSessions,
  ShowSessions,
  setIsLoaded,
  setShowAddSessions,
  ShowAddSessions,
  userBalance,
}) => {
  let navigate = useNavigate();
  let CurrentUser = useContext(UserContext);
  const [AmountToPay, setAmountToPay] = useState(0);
  const { translations } = useContext(LanguageContext);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [isPayFromBalance, setIsPayFromBalance] = useState(false);

  const PayAmount = async () => {
    // if (AmountToPay < 1) {
    //     Swal.fire({
    //         title: 'Error',
    //         text: 'Please enter a valid amount to pay',
    //         icon: 'error',
    //         confirmButtonText: 'Ok'
    //     })
    //     return;
    // }

    if (!paymentMethod) {
      Swal.fire({
        title: "Error",
        text: "Please enter a Payment Method",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    let req = new CreateAccountingEntryReq();

    req.Amount = AmountToPay;
    req.Description = "Payment for Package " + Package.packageName;
    req.isProfit = true;
    req.packageId = Package.id;
    req.title = "Payment for Package " + Package.packageName;
    req.entryType = "Package";
    req.creatorId = CurrentUser.id;
    req.paymentMethod = paymentMethod;
    let res = await AccountingApi.CreateAccountingEntry(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const payAmountFromUserBalance = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    let req = new PayFromBalanceReq();
    req.amountToPay = AmountToPay;
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    let res = await AccountingApi.PayFromUserBalanceForPackage(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const transferAvailableBalance = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    let req = new PayFromBalanceReq();
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    let res = await AccountingApi.transferAvailableAmount(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const transferRefundableAmount = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    let req = new PayFromBalanceReq();
    req.packageId = Package.id;
    req.userId = Package.getPatient.getUser.id;
    let res = await AccountingApi.transferRefundableAmount(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const RefundPackage = async () => {
    let refReq = new RefundReq();
    refReq.packageId = Package.id;
    refReq.creatorId = CurrentUser.id;
    refReq.refundType = "Package";

    let res = await AccountingApi.Refund(refReq);

    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Refund successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: "Refund failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const DeletePackage = async () => {
    let confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmation.value) {
      return;
    }

    let req = new SearchStringOrIntReq();
    req.SearchInt = Package.id;

    let res = await SessionsApi.DeletePackage(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Package deleted",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        navigate("/Accountingsessions");
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Package deletion failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const GetAmountAvailable = () => {
    let totalPaid = 0;
    Package.getAccountingSessions.map((AccSession) => {
      totalPaid += AccSession.isPaidFor ? AccSession.finalPrice : 0;
    });
    return Package.amountPaid - totalPaid;
  };

  const TogglePostPaid = async () => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    let req = new SearchStringOrIntReq();
    req.SearchInt = Package.id;

    let res = await AccountingApi.TogglePackagePostPaid(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Package updated",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Package update failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  return (
    <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.PackageInfoPackageInfo}
        </MDTypography>
        <MDButton onClick={() => DeletePackage()} variant="gradient" color="dark">
          <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
          &nbsp;{translations.PackageInfoDeletepackage}
        </MDButton>
      </MDBox>

      <div className="grid-container">
        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoName}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {Package.getPatient.getUser.name}{" "}
          </MDTypography>
          {/*  <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{Package.packageName}
                    </MDTypography> */}
        </div>

        <div className="child-grid">
          <MDBox>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.PackageInfoPackageId}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Package.id}
            </MDTypography>
          </MDBox>
        </div>
        <div className="child-grid">
          <MDBox>
            {Package.isPaidFor ? (
              <>
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {" "}
                  {translations.PackageInfoStatus}{" "}
                </MDTypography>{" "}
                :{" "}
                <MDTypography variant="button" fontWeight="regular" color="success">
                  {translations.PackageInfoPaid}
                </MDTypography>
              </>
            ) : (
              <>
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {" "}
                  {translations.PackageInfoStatus}{" "}
                </MDTypography>{" "}
                :{" "}
                <MDTypography variant="button" fontWeight="regular" color="red">
                  {translations.PackageInfoNotPaid}
                </MDTypography>
              </>
            )}
          </MDBox>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoOriginalPrice}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.originalPrice}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoDiscount}
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Number(Package.discount).toFixed(1)}%
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoFinalPrice}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.finalPrice}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoCreatedAt}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.timeStamp.split("T")[0]}
          </MDTypography>
        </div>
      </div>
      <hr style={{ margin: "20px 0", border: "none", borderTop: "1px solid #ccc" }} />
      <div className="grid-container">
        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoAmountRemaining}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.amountDue}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoAmountDiscounted}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.discountedAmount}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoDiscountedAmountUsed}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.discountedAmountUsed}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoRefundableAmount}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular">
            &nbsp;{Package.refundableAmount}
          </MDTypography>
        </div>
        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoAmountPaid} ({translations.PackageInfoPackageBalance}): &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.amountPaid}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoAmountUsed} ({translations.PackageInfoAdmitted}): &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Package.amountUsed}
          </MDTypography>
        </div>

        <div className="child-grid">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoAmountAvailable} ({translations.PackageInfoFromPackageBalance})
            : &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;
            {GetAmountAvailable()}
          </MDTypography>
        </div>
        <div style={{ display: "flex" }}>
          <button
            className="btn btn-primary"
            style={{ marginRight: "10px" }}
            onClick={() => {
              transferRefundableAmount();
            }}
          >
            {translations.TransferPackageInfoRefundableAmount}
          </button>
          <button
            className="btn btn-primary"
            style={{ marginRight: "10px" }}
            onClick={() => {
              transferAvailableBalance();
            }}
          >
            {translations.TransferPackageInfoAmountAvailable}
          </button>
        </div>
      </div>
      <hr style={{ margin: "20px 0", border: "none", borderTop: "1px solid #ccc" }} />
      <div
        className="grid-container"
        style={{ display: "flex", flexDirection: "column", gap: "10px" }}
      >
        <div className="child-grid" style={{ display: "flex", alignItems: "center" }}>
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoShowSessions}: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch checked={ShowSessions} onChange={() => setShowSessions(!ShowSessions)} />
          </MDBox>
        </div>

        <div className="child-grid" style={{ display: "flex", alignItems: "center" }}>
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoAddSessions}: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch
              checked={ShowAddSessions}
              onChange={() => setShowAddSessions(!ShowAddSessions)}
            />
          </MDBox>
        </div>

        <div className="child-grid" style={{ display: "flex", alignItems: "center" }}>
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.PackageInfoPostPaid}
          </MDTypography>
          <MDBox>
            <Switch
              checked={Package.postPaid}
              onChange={() => {
                TogglePostPaid();
              }}
            />
          </MDBox>
        </div>
      </div>

      <div style={{ paddingLeft: "20px" }}>
        <div className="child-grid" style={{ display: "flex", alignItems: "center" }}>
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            Pay From User Balance: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch
              checked={isPayFromBalance}
              onChange={() => setIsPayFromBalance(!isPayFromBalance)}
            />
          </MDBox>
        </div>
      </div>

      <div className="pay-amount-container">
        {isPayFromBalance && (
          <p style={{ color: "green", textAlign: "left" }}>
            <PersonPinCircleRounded /> {translations.userBalance}: {userBalance}$
          </p>
        )}
        <div className="pay-details">
          <div className="info-labels">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.PackageInfoPayAmount}:
            </MDTypography>
          </div>

          <MDInput
            type="number"
            variant="standard"
            value={AmountToPay}
            onChange={(e) => setAmountToPay(e.target.value)}
            className="amount-input"
          />
        </div>

        <div className="payment-method-container">
          {!isPayFromBalance && (
            <select value={paymentMethod} onChange={handleChange} className="payment-selector">
              <option value="" disabled>
                {translations.SelectPaymentmethod}
              </option>
              <option value="Visa">{translations.SelectPaymentmethodvisa}</option>
              <option value="Cash">{translations.SelectPaymentmethodCash}</option>
              <option value="Bank-transfer">{translations.SelectPaymentmethodBankTransfer}</option>
            </select>
          )}
          {!isPayFromBalance && (
            <button className="btn btn-primary" onClick={PayAmount} disabled={!paymentMethod}>
              {translations.PackageInfoPay}
            </button>
          )}
          {isPayFromBalance && (
            <button className="btn btn-primary" onClick={payAmountFromUserBalance}>
              {translations.PackageInfoPayUserBalance}
            </button>
          )}

          {/* <GenerateReceiptButton className="pay-btn" Package={Package} ReceiptType="Package" /> */}
        </div>
      </div>

      <div className="refund-btn">
        <button
          className="btn  btn-danger"
          onClick={() => {
            RefundPackage();
          }}
        >
          {translations.PackageInfoRefundPackage}
        </button>
      </div>
    </Card>
  );
};

export default PackageDetailsCard;
